import Api from '../api';
import UrlGenerator from '../url';

interface TransactionFilterBuilder {
  getFormatted(): Record<string, unknown>;
}

interface GetFiltersResponse {
  statuses: Record<string, unknown>;
  moneyServices: Record<string, unknown>;
}

interface GetTransactionsParams {
  page: number;
  perPage: number;
}

interface GetTransactionsResponse {
  transactions: unknown[];
  paginator: {
    page: number;
    pageSize: number;
    total: number;
  };
}

export default {
  getQuote(searchParams: Record<string, string>) {
    const urlSearchParams = new URLSearchParams(searchParams);
    return Api().get<unknown>(`/transaction/quote/?${urlSearchParams.toString()}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  },

  repeatTransactionByInvoice(invoice: string, wallet: string) {
    const url = UrlGenerator.generate(`/legacy-api/transaction/${invoice}/repeat/`, { wallet });
    return Api().get<unknown>(url);
  },

  // Transaction filters
  getFilters(): Promise<GetFiltersResponse> {
    return Api()
      .get<Record<string, unknown>>(UrlGenerator.generate('/member/transactions/filter/'))
      .then((response) => {
        const data: Record<string, unknown> = response.data || {};
        const { transactionStatuses, transactionMoneyServices } = data;

        return {
          statuses: (transactionStatuses as Record<string, unknown>) || {},
          moneyServices: (transactionMoneyServices as Record<string, unknown>) || {},
        };
      });
  },
  // Transaction list
  getTransactions(TransactionFilterBuilder: TransactionFilterBuilder, { page, perPage }: GetTransactionsParams): Promise<GetTransactionsResponse> {
    if (!page) {
      return Promise.reject(
        new Error('Invalid request: initial page is unset.'),
      );
    }

    if (!perPage) {
      return Promise.reject(
        new Error('Invalid request: items per page is not configured.'),
      );
    }

    return Api()
      .get<Record<string, unknown>>(UrlGenerator.generate('/member/transactions/search/'), {
        params: {
          ...TransactionFilterBuilder.getFormatted(),
          page: page,
          limit: perPage,
        },
      })
      .then((response) => {
        const data: Record<string, unknown> = response.data || {};
        return {
          transactions: (data.transactions as unknown[]) || [],
          paginator: {
            page: (data.page as number) || page,
            pageSize: (data.pageSize as number) || perPage,
            total: (data.total as number) || 0,
          },
        };
      });
  },
  checkoutTransactionByInvoice(invoice: string) {
    // NOTE: no matching route exists for this path (no 'checkout' pattern in the
    // api/transaction URL rule) — this call 404s today and is likely dead code.
    const url = UrlGenerator.generate(`/legacy-api/transaction/${invoice}/checkout/`);
    return Api().put<unknown>(url);
  },
  saveUserSettings(settings: { language: string }) {
    const url = UrlGenerator.generate('/member/profile-settings/api-save/');
    return Api().post(url, settings);
  },
};
